export const SageSetupValidation = (formData) => {
    const errors = {};

    // Validate each field
    if (!formData.ClientKey.trim()) {
        errors.ClientKey = 'This field is required';
    }
    if (!formData.ClientSecret.trim()) {
        errors.ClientSecret = 'This field is required';
    }
    if (!formData.SubscriptionKey.trim()) {
        errors.SubscriptionKey = 'This field is required';
    }

    return errors;
};

